import Vue from 'vue'
// @ts-ignore
import NoSsr from 'vue-no-ssr'
import { mapGetters } from 'vuex'
import {
  BROWSE_JOBS,
  BROWSE_JOBS_BY_SKILL,
  DASHBOARD,
  MY_JOBS,
  PREMIUM,
  REFERRALS,
  SERVICE_BY_SKILL,
  SERVICE_MY,
  SERVICES,
  SETTINGS,
  VACANCIES,
  VACANCIES_MY,
  WALLETS,
} from '@/constants/routes'
import { Roles } from '@/constants/user/roles'
import rolebleMixin from '@/mixins/rolebleMixin'
import zendeskMixin from '@/mixins/zendeskMixin'

export default Vue.extend<any, any, any, any>({
  mixins: [rolebleMixin, zendeskMixin],
  components: {
    NoSsr,
  },
  data() {
    return {
      DASHBOARD,
      BROWSE_JOBS,
      MY_JOBS,
      SETTINGS,
      PREMIUM,
      REFERRALS,
      BROWSE_JOBS_BY_SKILL,
      SERVICES,
      SERVICE_MY,
      SERVICE_BY_SKILL,
      VACANCIES,
      VACANCIES_MY,
      WALLETS,
    }
  },
  computed: {
    ...mapGetters({
      activeProfile: 'user/activeProfile',
    }),
    isFreelancer() {
      return this.activeProfile === Roles.FREELANCER
    },
    isBrowseVacancies() {
      return this.$route.name === VACANCIES
    },
    isBrowseJobs() {
      return [BROWSE_JOBS, BROWSE_JOBS_BY_SKILL].includes(this.$route.name)
    },
    isServices() {
      return [SERVICES, SERVICE_BY_SKILL].includes(this.$route.name)
    },
    isVacancies() {
      return this.$route.name === VACANCIES
    },
  },
  methods: {
    onClickSupport() {
      if (!this.isZendeskLoading) {
        this.openZendesk('My account')
      }
    },
  },
})
